import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../../ls2pac/ApplicationData";
import { AvailabilityClientManager } from "../../ls2pac/ClientManagers/AvailabilityClientManager";
import { TeachingBooksClientManager } from "../../ls2pac/ClientManagers/TeachingBooksClientManager";
import { AcceleratedReaderUtil } from "../../ls2pac/utils/AcceleratedReaderUtil";
import { CopiesTableRenderer } from "../../ls2pac/utils/CopiesTableRenderer";
import { LS2PAC_Utils } from "../../ls2pac/utils/Utils";
import { ResourceUtils } from "../../ls2pac/utils/resourceUtils";
import { BaseView } from "../../ls2pac/views/BaseView";
import { LibraryThing } from "../../ls2pac/widget/LibraryThingWidget";
import { KidsAddCoverArt } from "../addCoverArt";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsHistoryManager } from "../managers/HistoryManager";
import { KidsMessaging } from "../messaging";
import { KidsUtil } from "../utils";

export class KidsFullDetailsView extends BaseView {
	constructor() {
		super({
			id: LS2KIDS_CONSTANTS.Ids.FullDetails.fullDetailsContainer,
			targetId: LS2KIDS_CONSTANTS.Ids.app,
			viewClass: 'baseView'
		});

		this._inited = false;
		this.teachingBooksTitleId = null;

		this.addListeners();
	}
	addListeners() {
		var _this = this;

		this.setShowEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails);

		this.setHideEvent(LS2PAC_CONSTANTS.Events.onSearch);
		this.setHideEvent(LS2KIDS_CONSTANTS.Events.onStartCategoryView);
		this.setHideEvent(LS2KIDS_CONSTANTS.Events.onStartSeriesView);
		this.setHideEvent(LS2KIDS_CONSTANTS.Events.onStartResultsView);

		TLCEventManager.addListener(
			LS2PAC_CONSTANTS.Events.onGetFullDetailsFromMarcRecordResponse,
			function (event) {
				_this.showResource(event);
			}
		);

		TLCEventManager.addListener(
			LS2PAC_CONSTANTS.Events.onViewNullResource,
			function (event) {
				KidsMessaging.show(ApplicationData.language.kidsInvalidResourceIdDeepLinkMessage);
			}
		);

		$('body').on('keyup', function (event) {
			if (!_this.isActive) {
				return;
			}

			if (event.keyCode == 27) {
				_this.closeDetails();
			}
		});

	}
	closeDetails() {
		var url = this.$view.find('.closeButton').attr('href');

		KidsHistoryManager.navigate(url);
	}
	_createiScroll() {
		if (!window.Modernizr.csstransitions) {
			this.$view.addClass('detailsContainerNoIScroll');

			return;
		}

		var _this = this;

		this.$view.addClass('has-iscroll');

		this._iScroll = new window.IScroll("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.tabContentWrapper, {
			mouseWheel: true,
			scrollX: false,
			scrollY: true,
			click: true,
			fadeScrollbars: false,
			momentum: true,
			interactiveScrollbars: true,
			shrinkScrollbars: 'scale',
			scrollbars: 'custom'
		});

		this._iScroll.on('scrollEnd', function () {
			_this._updateDetailsNav();
		});
	}
	updateAndSubmitTeachingBooksForm(teachingBooksData) {
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm).attr('action', teachingBooksData.link);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm + " input[name=oauth_callback]").val(teachingBooksData.oauthCallback);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm + " input[name=oauth_consumer_key]").val(teachingBooksData.oauthConsumerKey);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm + " input[name=oauth_nonce]").val(teachingBooksData.oauthNOnce);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm + " input[name=oauth_signature]").val(teachingBooksData.oauthSignature);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm + " input[name=oauth_signature_method]").val(teachingBooksData.oauthSignatureMethod);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm + " input[name=oauth_timestamp]").val(teachingBooksData.oauthTimestamp);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm + " input[name=oauth_version]").val(teachingBooksData.oauthVersion);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm + " input[name=lti_version]").val(teachingBooksData.ltiVersion);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm + " input[name=lti_message_type]").val(teachingBooksData.ltiMessageType);
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm).trigger("submit");
	}
	initDOMEvents() {
		var _this = this;

		this.$view.on('click touchend', '#closeModalButton', function (e) {
			e.preventDefault();
			_this.closeDetails();
		});

		this.$view.on('click touchend', function (e) {
			if (e.target == e.currentTarget) {
				_this.closeDetails();
			}
		});

		this.$view.on('click touchend', '.hold-resource-button', function (e) {
			e.preventDefault();
			_this.initiateHold(_this, e);
		});

		this.$view.on('click touchend', '.teachingBooksLink', function (e) {
			e.preventDefault();
			TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onTeachingBooksButtonClick, {
				tid: _this.teachingBooksTitleId,
				callbackFunc: _this.updateAndSubmitTeachingBooksForm
			});
		});

	}
	initiateHold(_this, e) {
		var currentUser = ApplicationData.getCurrentUser();

		if (KidsUtil.canAddDownloadableSourceLink(_this.currentResource)) {
			window.open(_this.currentResource.link);
		} else if (KidsUtil.canCheckoutResource(_this.currentResource)) {
			TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onPromptToHoldResource, {
				resource: _this.currentResource,
				available: _this.isAvailable,
				event: e
			});
		} else if (currentUser != null && currentUser.username == "tlcadmin") {
			KidsMessaging.showThenHide("Hey bro, you can't do that.", 5000);
		}
	}
	show(event) {
		super.show(arguments);

		if (!this._inited) {
			this._inited = true;

			this.initDOMEvents();
		}

		this.renderDetails(event);
		this.getResourceTitleDetails(event);

		KidsUtil.showBackdrop();
	}
	refreshSU(metaData) {
		var _this = this;
		var selector = '#' + LS2KIDS_CONSTANTS.Ids.FullDetails.summaryContainer + " .summary";
		var retryCallback = function () {
			_this.refreshSU(metaData);
		};
		$.when(LibraryThing.refreshMetaData(selector, metaData, retryCallback)).always(function () {
			_this.onResize();
		});
	}
	initSummary() {
		$('#' + LS2KIDS_CONSTANTS.Ids.FullDetails.summaryContainer).show();
		$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.summaryTab).show();
		this.$view
			.find('#' + LS2KIDS_CONSTANTS.Ids.FullDetails.summaryContainer).append('<div class="summary"></div>');
		var summaryContainer = this.$view
			.find('#' + LS2KIDS_CONSTANTS.Ids.FullDetails.summaryContainer).find(".summary");
		summaryContainer.empty();
		LibraryThing.addEnrichment(summaryContainer, LibraryThing.enums.enrichments.summary);
		this.refreshSU(this.currentResource);
	}
	showDetails(event) {
		var _this = this;

		this.currentResource = event.resourceData.resources[0];

		this.$view
			.find('a.closeButton')
			.attr('href', KidsHistoryManager.buildUrl(event.history.previous));

		this._$detailsNav = $("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.tabber);
		this._$contentWrapper = $("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.tabContentWrapper);
		this._$tabPanelWrapper = $("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.tabPanelWrapper);

		var $jacketElement = this.$view.find("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.mainJacket);


		if (LibraryThing.hasSummary()) {
			this.initSummary();
		}
		else {
			$('#' + LS2KIDS_CONSTANTS.Ids.FullDetails.summaryContainer).hide();
			$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.summaryTab).hide();
		}

		KidsAddCoverArt.load($jacketElement, {
			requestType: LibraryThing.enums.requestType.bookJacketLarge,
			resources: event.resourceData.resources,
			index: 0,
			displayDummyJacket: true,
			callback: function (isDummy) { }
		});

		KidsUtil.appendFormatIcon(this.currentResource, $jacketElement.parent());

		if (ApplicationData.locationConfiguration.isTeachingBooksEnabled()) {
			TeachingBooksClientManager.getTeachingBooksTitleId(_this.currentResource, function (titleId) {
				if (titleId) {
					_this.teachingBooksTitleId = titleId;
					$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksLink).show();

					// $("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm).attr('action', teachingBooksData.link);
					// var callback = $("<input>").attr("type", "hidden").attr("name", "oauth_callback").val(teachingBooksData.oauthCallback);
					// var key = $("<input>").attr("type", "hidden").attr("name", "oauth_consumer_key").val(teachingBooksData.oauthConsumerKey);
					// var nonce = $("<input>").attr("type", "hidden").attr("name", "oauth_nonce").val(teachingBooksData.oauthNOnce);
					// var signature = $("<input>").attr("type", "hidden").attr("name", "oauth_signature").val(teachingBooksData.oauthSignature);
					// var sigMethod = $("<input>").attr("type", "hidden").attr("name", "oauth_signature_method").val(teachingBooksData.oauthSignatureMethod);
					// var oTimeStmp = $("<input>").attr("type", "hidden").attr("name", "oauth_timestamp").val(teachingBooksData.oauthTimestamp);
					// var oVersion = $("<input>").attr("type", "hidden").attr("name", "oauth_version").val(teachingBooksData.oauthVersion);
					// var ltiVersion = $("<input>").attr("type", "hidden").attr("name", "lti_version").val(teachingBooksData.ltiVersion);
					// var ltiMsgType = $("<input>").attr("type", "hidden").attr("name", "lti_message_type").val(teachingBooksData.ltiMessageType);
					// $("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.teachingBooksForm)
					// 	.append(callback, key, nonce, signature, sigMethod, oTimeStmp, oVersion, ltiVersion, ltiMsgType);
				}
			});
		}

		CopiesTableRenderer.append(
			$("#" + LS2KIDS_CONSTANTS.Ids.FullDetails.copiesTabContent),
			this.currentResource,
			true,
			false,
			function () {
				_this.onResize();
			}
		);
		_this.attachEventListeners();

		var addressBarText = window.location.href.toString();
		if (addressBarText.indexOf("showAccountLinkedMsg=true") !== -1) {
			var user = ApplicationData.getCurrentUser();
			KidsMessaging.confirm({
				message: ApplicationData.language.kidsLinkedGoogleAccount.replace("%NAME%", user.firstName),
				successButton: ApplicationData.language.ok,
				successCallback: function () {
					_this.initiateHold(_this, event);
				},
				failCallback: function () {
					TLCEventManager.fireEvent(LS2KIDS_CONSTANTS.Events.onStartAutoCycle);
				}
			});
		} else if (addressBarText.indexOf("&oauthAuthenticated=true") !== -1) {
			_this.initiateHold(_this, event);
		}
	}
	renderDetails(event) {
		var _this = this;

		TemplateEngine.fetch(
			'tmpl/kids/results/fullDetails.html',
			"#" + this.id,
			event,
			function () {
				$("#tabContentWrapper").scrollTop(0);
				_this._createiScroll();
				_this.showAvailability(event);
				_this.showDetails(event);
			},
			TemplateEngine.method.overwrite
		);
	}
	showAvailability(event) {
		var _this = this;

		AvailabilityClientManager.getItemAvailability(
			[event.currentResource],

			/**
			 * @function
			 * @param {Object} availabilityResources
			 */
			function (availabilityResources) {
				var availabilityResource = availabilityResources[0];

				var icon = KidsUtil.getAvailabilityIcon(
					availabilityResource
				);

				_this.isAvailable = icon.data('available');

				_this.$view.find('.innerContainer').prepend(icon);

				var className = "";

				if (ApplicationData.locationConfiguration.getAllowHolds().title || availabilityResource.downloadable) {
					if (!KidsUtil.canCheckoutResource(availabilityResource) &&
						!KidsUtil.canAddDownloadableSourceLink(availabilityResource)) {
						className = "disabled";
					}
				} else {
					className = "disabled";
				}

				_this.$view.find('.hold-resource-button-container')
					.addClass(className)
					.show();

			},
			false,
			false
		);
	}
	attachEventListeners() {
		var _this = this;
		var mouseEnterDelay = null;
		var headerTimeout = null;

		this._$contentWrapper.on('scroll', function (e) {
			_this._updateDetailsNav();
		});

		this._$detailsNav.on('mouseenter', 'a', function (e) {
			var $liEle = $(e.currentTarget).parent();
			var index = $liEle.parent().children().index($liEle);
			var $focusEle = $(_this._$tabPanelWrapper.children().get(index));

			mouseEnterDelay = setTimeout(function () {
				_this._$tabPanelWrapper.addClass('focus-single-tab');

				$focusEle.addClass('focus');
			}, 250);
		});

		this._$detailsNav.on('mouseleave', 'a', function (e) {
			clearTimeout(mouseEnterDelay);
			var $liEle = $(e.currentTarget).parent();
			var index = $liEle.parent().children().index($liEle);
			var $focusEle = $(_this._$tabPanelWrapper.children().get(index));

			_this._$tabPanelWrapper.removeClass('focus-single-tab');

			$focusEle.removeClass('focus');
		});


		this._$detailsNav.on('click', 'a', function (e) {
			e.preventDefault();

			var $liEle = $(e.currentTarget).parent();
			var index = $liEle.parent().children().index($liEle);
			var $focusEle = $(_this._$tabPanelWrapper.children().get(index));

			if (_this._iScroll) {
				_this._iScroll.scrollToElement(_this._positions[index].header.ele, undefined, 0, -16);
			} else {
				$("#tabContentWrapper").scrollTop(_this._positions[index].header.ele.offsetTop - 16);
			}

			$focusEle.addClass('header-focus');

			headerTimeout = setTimeout(function () {
				$focusEle.removeClass('header-focus');

				headerTimeout = null;
			}, 400);

			TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onFocusFullDetailsSection, {
				sectionName: $(_this._positions[index].header.ele).text()
			});
		});

		window.requestAnimationFrame(function () {
			_this.$view.children().removeClass('hide-opacity');
		});
	}
	hide() {
		super.hide();

		KidsUtil.hideBackdrop();
	}
	getResourceTitleDetails(event) {
		TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetFullDetailsFromMarcRecord, {
			resource: {
				id: event.resourceData.resources[event.index].id
			}
		});
	}
	showResource(event) {
		var _this = this;

		this.showReadingLevels();

		TemplateEngine.fetch(
			'tmpl/kids/results/titles_fullDetails_marcData.html',
			'#' + LS2KIDS_CONSTANTS.Ids.FullDetails.detailsContainer,
			event.details,
			function () {
				_this.onResize();
			}
		);
	}
	showReadingLevels() {
		var _this = this;
		var isThereInfo = AcceleratedReaderUtil.isThereAnyReadingLevelInfo(this.currentResource);
		if (ApplicationData.locationConfiguration.areReadingLevelsEnabled() && isThereInfo) {
			this.$view
				.find('#' + LS2KIDS_CONSTANTS.Ids.FullDetails.readingLevelTab)
				.show();

			this.$view
				.find('#' + LS2KIDS_CONSTANTS.Ids.FullDetails.readingLevelContainer)
				.show();

			TemplateEngine.fetch(
				'tmpl/kids/results/titles_fullDetails_readingLevels.html',
				'#' + LS2KIDS_CONSTANTS.Ids.FullDetails.readingLevelContainer,
				this.currentResource,
				function () {
					_this.onResize();
				}
			);
		}
	}
	onResize() {
		this._calculateHeaderPositions();
		this._updateDetailsNav();

		if (this._iScroll != null) {
			this._iScroll.refresh();
		}

	}
	_updateDetailsNav() {
		this._$detailsNav.children().removeClass('active');

		if (this._positions == null) {
			return;
		}

		var top = this._iScroll
			? Math.abs(this._iScroll.y)
			: this._$contentWrapper.get(0).scrollTop;

		for (var i = 0, len = this._positions.length; i < len; i += 1) {
			var positions = this._positions[i];

			if (positions.content.bottom > top) {
				$(this._$detailsNav.children().get(i)).addClass('active');
				break;
			}
		}
	}
	_calculateHeaderPositions() {
		this._positions = [];

		var headerEles = this._$contentWrapper.find('h2');

		for (var i = 0, len = headerEles.length; i < len; i += 1) {
			var headerEle = headerEles[i];
			var $headerEle = $(headerEle);

			var headerHeight = $headerEle.height();
			var headerTop = headerEle.offsetTop;

			var nextEle = $headerEle.parent();

			//		if( nextEle.length > 0 ) {
			var eleTop = nextEle.get(0).offsetTop;
			var eleHeight = nextEle.height();

			//			if( eleHeight != 0 ) {
			this._positions.push({
				header: {
					ele: headerEle,
					top: headerTop,
					height: headerHeight,
					bottom: headerHeight
				},
				content: {
					bottom: eleTop + eleHeight - 50,
					top: eleTop,
					height: eleHeight
				}
			});
			//			}
			//		}
		}

		this._updateDetailsNav();
	}
	render() { }
}

KidsFullDetailsView.prototype._activeViews = null;
KidsFullDetailsView.prototype._iScroll = null;
KidsFullDetailsView.prototype._positions = null;
KidsFullDetailsView.prototype._inited = null;


























